import { render } from "./MenuTableView1.vue?vue&type=template&id=07da22e2&scoped=true"
import script from "./MenuTableView1.vue?vue&type=script&lang=js"
export * from "./MenuTableView1.vue?vue&type=script&lang=js"

import "./MenuTableView1.vue?vue&type=style&index=0&id=07da22e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07da22e2"]])

export default __exports__